import { useTheme } from '@emotion/react';
import React from 'react';

import { Name, Table, Text } from '~/components/blocks';
import { getRoleLabel } from '~/utils/practitioners';

type Props = {
  id: string;
  familyName: string;
  givenName: string;
  phoneticFamilyName: string;
  phoneticGivenName: string;
  username: string;
  roles: string[];
  twoFactorAuthenticationConfigured: boolean;
  displayTwoFactorAuthentication: boolean;
  editable: boolean;
  onOpenEditDrawer: (practitionerId: string) => void;
};

export const Practitioner = React.memo((props: Props) => {
  const theme = useTheme();
  const { editable, onOpenEditDrawer } = props;

  return (
    <Table.Tr onClick={editable ? () => onOpenEditDrawer(props.id) : undefined}>
      <Table.Td>
        <Name
          familyName={props.familyName}
          givenName={props.givenName}
          phoneticFamilyName={props.phoneticFamilyName}
          phoneticGivenName={props.phoneticGivenName}
        />
      </Table.Td>
      <Table.Td>{props.username}</Table.Td>
      <Table.Td>
        {props.roles.map((role, idx) => {
          return (
            <Text key={idx} mr={theme.space.m}>
              {getRoleLabel(role)}
            </Text>
          );
        })}
      </Table.Td>
      {props.displayTwoFactorAuthentication && (
        <Table.Td>
          {props.twoFactorAuthenticationConfigured ? (
            <Text>設定済み</Text>
          ) : (
            <Text color="pink">未設定</Text>
          )}
        </Table.Td>
      )}
    </Table.Tr>
  );
});

Practitioner.displayName = 'Practitioner';
